import { getInclusionOptions } from '../logicHelpers'
import { useQuestionStore } from '@dashboard/modules/segment/stores/questionStore'
import { useWidgetStore } from '@dashboard/modules/widget/stores/widgetStore'
import { stripHtml } from '@dashboard/services/string'
import { storeToRefs } from 'pinia'

const rightmessageSource = (context: { offerFunnelId?: string } = {}) => {
  const questionStore = useQuestionStore()
  const { questions } = storeToRefs(questionStore)

  return {
    types: [
      { label: 'Current Widget', value: 'widget', description: 'The widget showing this flow' },
      { label: 'Question Engagement', value: 'question', description: 'Questions answered on this page' }
    ],
    inputs: [
      {
        control: 'select',
        key: 'widget-operator-select',
        id: 'operator',
        name: 'operator',
        options: getInclusionOptions(),
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'rightmessage' && condition.$type === 'widget'
      },
      {
        control: 'autocomplete',
        key: 'widget-value',
        name: 'value',
        multiple: true,
        options: () => {
          const offerFunnelId = context.offerFunnelId
          if (!offerFunnelId) {
            return []
          }
          const widgetStore = useWidgetStore()
          const widgets = widgetStore.getWidgetsForOfferFunnel(offerFunnelId)

          return widgets.map((widget) => ({
            label: widget.name,
            value: widget.id
          }))
        },
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'rightmessage' && condition.$type === 'widget'
      },
      {
        control: 'select',
        key: 'question-operator-select',
        id: 'operator',
        name: 'operator',
        options: getInclusionOptions(),
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'rightmessage' && condition.$type === 'question'
      },
      {
        control: 'multiselect',
        key: 'question-value-select',
        name: 'questionId',
        multiple: true,
        'open-on-focus': true,
        'clear-search-on-open': true,
        options: questions.value.map((question) => ({
          label: stripHtml(question.text),
          value: question.id
        })),
        can: (condition: { $source: string; $type: string; operator: string }) =>
          condition.$source === 'rightmessage' &&
          condition.$type === 'question' &&
          (condition.operator || '').includes('include')
      },
      {
        control: 'select',
        key: 'question-scope-select',
        id: 'scope',
        name: 'scope',
        options: [
          {
            label: 'this page view',
            value: 'pageview'
          }
          // {
          //   label: 'in the last',
          //   value: 'timeframe'
          // }
        ],
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'rightmessage' && condition.$type === 'question'
      }
    ]
  }
}

export default rightmessageSource
